export default function vconsole () {
  return import(
    /* webpackChunkName: "vconsole" */
    'vconsole'
  );
}

